export const NAME = 'productsCatalog';
